import { TextField, MenuItem, SxProps } from '@mui/material'

function generateTimeOptions() {
  const options = []
  const pad = (n) => n.toString().padStart(2, '0')

  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 5) {
      const hour12 = h % 12 === 0 ? 12 : h % 12
      const period = h < 12 ? 'am' : 'pm'
      const label = `${pad(hour12)}:${pad(m)}${period}`
      const value = `${pad(h)}:${pad(m)}`
      options.push({ label, value })
    }
  }
  return options
}

const timeOptions = generateTimeOptions()

type TimePickerDropdownProps = {
  value: string
  label: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  name?: string
  sx?: SxProps
  fullWidth?: boolean
}

export const TimePickerDropdown = ({
  value,
  label,
  onChange,
  sx,
  fullWidth,
  name = 'time',
}: TimePickerDropdownProps) => {
  const options: GenericSimpleBag = {}
  if (fullWidth) {
    options.fullWidth = true
  }

  if (sx) {
    options.sx = sx
  }

  return (
    <TextField select label={label} value={value} onChange={onChange} name={name} {...options}>
      {timeOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
